import React from "react";
import { Row, Col, Image, Card } from "react-bootstrap";
import Smarttechnology from "../../../assets/img/Smarttechnology.svg";
import Toprated from "../../../assets/img/Toprated.svg";
import Competitive from "../../../assets/img/Competitive.svg";
import Slider from "../../../assets/img/Slider.png";
import Professional from "../../../assets/img/Professional.png";
import Client from "../../../assets/img/Client.png";
import Client2 from "../../../assets/img/Client2.png";
import Professional2 from "../../../assets/img/Professional2.png";
import missionImage from "../../../assets/img/missionImage.png";

const AboutUs = () => {
  return (
    <>
      <div className="about-us">
        <div
          className="mb-4 mb-md-5 padding_top banner_sec"
          style={{
            backgroundColor: "#B62727",
            color: "white",
          }}
        >
          <div className="custom_container">
            <Row className="px-0 pb-4 mb-lg-0 flex-column-reverse flex-md-row">
              <Col md={6}>
                <p
                  className="mb-0 mb-md-2 mt-0 mt-md-3"
                  style={{
                    fontWeight: "500",
                  }}
                >
                  OUR MISSION
                </p>
                <h1 className="mt-2 mt-sm-3 mt-md-4">
                  Revolutionizing Home
                  <br />
                  Renovation—One
                  <br />
                  Project at a Time.
                </h1>
                <p>
                  We believe a home should be a reflection of you—your needs,
                  your lifestyle, and your vision. But traditional renovation
                  processes are filled with obstacles: high-pressure sales
                  tactics, scheduling headaches, and time-consuming in-person
                  estimates.
                </p>
                <p className="mt-0 mt-sm-2 mt-md-3 mt-lg-5">
                  Our mission is to simplify home improvement by giving
                  homeowners direct access to top professionals, instant
                  measurements using cutting-edge camera technology, and
                  competitive bids—all without the hassle.
                </p>
              </Col>

              <Col
                md={6}
                className="text-center"
                style={{
                  borderRadius: "24px",
                }}
              >
                <Image
                  src={missionImage}
                  alt="Mission Visual"
                  className="Mission-Visual-img"
                  style={{
                    borderRadius: "24px",
                    objectFit: "cover",
                    width: "100%",
                  }}
                />
              </Col>
            </Row>
          </div>
        </div>

        <div className="custom_container">
          <Row className="px-0">
            <div className="mb-1 mb-md-4">
              <h4 className="text-center text-sm-start fw-bold mt-2 mt-md-5">
                How Do We Make It Happen?
              </h4>
              <p className="paragraph_style text-center text-sm-start ">
                We’ve built a seamless digital experience that eliminates the
                inefficiencies of traditional remodeling. By combining:
              </p>
            </div>

            <Col md={4} className="mb-4">
              <Card
                className="d-flex flex-column align-items-start p-3 height_aboutus_card h-100 w-100"
                style={{
                  borderRadius: "12px",
                  backgroundColor: "#f9f9f9",
                  border: "none",
                }}
              >
                <div className="mb-3 mt-3" style={{ width: "100%" }}>
                  <Image
                    src={Smarttechnology}
                    alt="Icon"
                    style={{ height: "40px", width: "40px" }}
                  />
                </div>

                <div>
                  <h6
                    className="fw-bold linear-gradient-red-text"
                    style={{
                      marginBottom: "8px",
                      background:
                        "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Smart Technology
                  </h6>
                  <p
                    className="text-muted mb-0"
                    style={{ fontSize: "0.95rem", lineHeight: "1.4" }}
                  >
                    Measure and submit projects in minutes using just your
                    smartphone.
                  </p>
                </div>
              </Card>
            </Col>
            <Col md={4} className="mb-4">
              <Card
                className="d-flex flex-column align-items-start p-3 height_aboutus_card h-100 w-100"
                style={{
                  borderRadius: "12px",
                  backgroundColor: "#f9f9f9",
                  border: "none",
                }}
              >
                <div className="mb-3 mt-3" style={{ width: "100%" }}>
                  <Image
                    src={Toprated}
                    alt="Icon"
                    style={{ height: "40px", width: "40px" }}
                  />
                </div>

                <div>
                  <h6
                    className="fw-bold linear-gradient-red-text"
                    style={{
                      marginBottom: "8px",
                      background:
                        "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Top-Rated Professionals{" "}
                  </h6>
                  <p
                    className="text-muted mb-0"
                    style={{ fontSize: "0.95rem", lineHeight: "1.4" }}
                  >
                    Connect with trusted experts who deliver quality work.
                  </p>
                </div>
              </Card>
            </Col>
            <Col md={4} className="mb-4">
              <Card
                className="d-flex flex-column align-items-start p-3 height_aboutus_card h-100 w-100"
                style={{
                  borderRadius: "12px",
                  backgroundColor: "#f9f9f9",
                  border: "none",
                }}
              >
                <div className="mb-3 mt-3" style={{ width: "100%" }}>
                  <Image
                    src={Competitive}
                    alt="Icon"
                    style={{ height: "40px", width: "40px" }}
                  />
                </div>

                <div>
                  <h6
                    className="fw-bold linear-gradient-red-text"
                    style={{
                      marginBottom: "8px",
                      background:
                        "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Competitive Bidding{" "}
                  </h6>
                  <p
                    className="text-muted mb-0"
                    style={{ fontSize: "0.95rem", lineHeight: "1.4" }}
                  >
                    Compare bids virtually, select the best option, and get
                    started—all from your device.{" "}
                  </p>
                </div>
              </Card>
            </Col>

            <div className="mb-3 mb-sm-4">
              <p className="paragraph_style">
                With SimpleRenovate, homeowners are in control. No unwanted
                sales calls. No in-home visits until you’re ready. Just
                straightforward, stress-free renovations from start to finish.
              </p>
            </div>
            {/* Repeat for other cards... */}
          </Row>
        </div>

        <div className="platform_sec">
          <div className="">
            <h1
              className="custom_container fw-bold d-flex justify-content-center"
              style={{ color: "#cc4645" }}
            >
              Your Vision + Our platform = A Smarter Way to Renovate.
            </h1>
          </div>
        </div>

        <div className="custom_container">
          <Row className="px-0 mt-3 mt-md-5 flex-column-reverse flex-md-row">
            <Col md={6} className="">
              <h1 className="mt-3 mt-md-0 redefining_text">
                Redefining the Industry.
              </h1>
              <p
                className="mb-3"
                style={{
                  fontSize: "1.5rem",
                  lineHeight: "1.3",
                  marginBottom: "16px",
                  fontWeight: "600",
                }}
              >
                Renovation should be efficient, transparent, and
                <br /> stress-free.
              </p>
              <p
                className="paragraph_style"
                style={{ lineHeight: "1.7", maxWidth: "530px" }}
              >
                With SimpleRenovate, we’re bringing innovation to the home
                improvement space. Our platform removes the outdated barriers
                between homeowners and professionals, making it easier than ever
                to get projects started with confidence.
              </p>
            </Col>

            {/* Image Column */}
            <Col md={6} className="text-center text-md-end mt-4 mt-md-0">
              <Image
                src={Slider}
                alt="Mission Visual"
                style={{
                  borderRadius: "24px",
                  objectFit: "cover",
                  width: "90%",
                }}
              />
            </Col>
          </Row>
        </div>

        <div className="custom_container pt-0 pt-xl-5">
          <Row className="px-0 mt-0 mt-md-5 margin_bottom_aboutus_flex">
            <Col md={6} className="margin_top_image_grid">
              <Row>
                {/* First Row */}
                <Col xs={6}>
                  <Image
                    src={Professional}
                    alt="Image 1"
                    style={{
                      width: "100%",
                      height: "350px",
                      objectFit: "fill",
                      borderRadius: "16px",
                    }}
                  />
                </Col>

                {/* Second Row */}
                <Col xs={6}>
                  <Image
                    src={Client2}
                    alt="Image 3"
                    style={{
                      width: "100%",
                      height: "180px", // smaller
                      objectFit: "fill",
                      borderRadius: "16px",
                    }}
                  />
                </Col>

                <Col xs={6}>
                  <Image
                    src={Client}
                    alt="Image 2"
                    style={{
                      width: "100%",
                      height: "180px",
                      objectFit: "fill",
                      borderRadius: "16px",
                    }}
                  />
                </Col>

                <Col xs={6}>
                  <Image
                    src={Professional2}
                    alt="Image 4"
                    style={{
                      width: "100%",
                      height: "370px",
                      borderRadius: "16px",
                      position: "relative",
                      bottom: "187px",
                    }}
                  />
                </Col>
              </Row>
            </Col>
            <Col className="mt-3 col_md_style" md={6}>
              <h1
                className="paragraph_style text-start text-md-end"
                style={{
                  fontWeight: "500",
                  marginBottom: "24px",
                }}
              >
                WHO WE ARE
              </h1>
              <p className="paragraph_style_bold">
                We’re a team of innovators, builders, and problem solvers who
                are passionate about construction, design, and technology.
              </p>
              <p className="paragraph_style_bold_2">
                We believe that technology should empower both homeowners and
                professionals—creating a smarter, more efficient renovation
                experience for everyone.
              </p>
            </Col>

            {/* Image Grid Column */}
          </Row>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
